var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"result"}},[_c('ul',_vm._l((_vm.collection),function(goal,index){return _c('list-item',{attrs:{"goal":goal,"index":index},on:{"selected":_vm.onClick}})}))])])}
var staticRenderFns = []

export { render, staticRenderFns }